import React from 'react';
import $ from 'jquery';

export class Checkbox extends React.Component {
  constructor(...args) {
    super(...args);
    this._changed = this._changed.bind(this);
  }

  static initClass() {
    this.defaultProps = {
      use_icheck: (typeof LOCALIST_SETTINGS !== 'undefined' && LOCALIST_SETTINGS !== null ? LOCALIST_SETTINGS.icheck : undefined),
      type: 'checkbox'
    };
  }

  componentDidMount() {
    if (this.props.use_icheck) { return this._initializeiCheck(); }
  }

  _initializeiCheck() {
    $(this.element).iCheck({
      checkboxClass: 'icheckbox_minimal',
      radioClass: 'iradio_minimal',
      increaseArea: '20%',
      labelHover: false
    });

    return $(this.element).on('ifChanged.checkbox_component', event => {
      return (typeof this.props.onChange === 'function' ? this.props.onChange(event, event.target.checked) : undefined);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.use_icheck && !this.props.use_icheck) {
      return $(this.element).iCheck('destroy').off('ifChanged.checkbox_component');
    } else if (!prevProps.use_icheck && this.props.use_icheck) {
      return this._initializeiCheck();
    }
      if (this.props.use_icheck) { return $(this.element).iCheck('update'); }

  }

  componentWillUnmount() {
    if (this.props.use_icheck) { return $(this.element).iCheck('destroy').off('ifChanged.checkbox_component'); }
  }

  _changed(event) {
    return (typeof this.props.onChange === 'function' ? this.props.onChange(event, event.target.checked) : undefined);
  }

  render() {
    return <input ref={(ref) => this.element = ref}
            {...this.props}
            onChange={this._changed} />;
  }
}
Checkbox.initClass();
